// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0ed5a8ca","239":"3b925ff3","455":"7a3ef913"}[chunkId] + ".chunk.js";
};